import { action, observable, runInAction } from "mobx";

import {
  ClinicalDataType,
  EncounterStatus
} from "@libs/gateways/clinical/ClinicalGateway.dtos.ts";
import { routes } from "@libs/routing/routes.ts";
import { IRootStore } from "@shared-types/root/root-store.interface.ts";
import { Encounter } from "@stores/clinical/models/Encounter.ts";

export class EncounterExistsPromptHelper {
  constructor(
    protected root: IRootStore,
    public patientId: string,
    public openedEncounterId: string | undefined
  ) {
    runInAction(() => {
      this.selectedEncounterId = this.openedEncounterId;
    });
  }
  get clinical() {
    return this.root.clinical;
  }

  get core() {
    return this.root.core;
  }

  get booking() {
    return this.root.booking;
  }

  get userId() {
    return this.core?.user?.id;
  }

  @observable selectedEncounterId: string | undefined;

  @action setSelectedEncounterId = (
    selectedEncounterId: string | undefined
  ) => {
    this.selectedEncounterId = selectedEncounterId;
  };

  fetchOpenEncounterDetail = async (openEncounter: Encounter) => {
    const encounterId = openEncounter.id;

    return Promise.all([
      this.clinical.getEncounterClinicalNote(encounterId),
      this.clinical.getEncounterClinicalData({
        encounterId,
        types: [ClinicalDataType.ReasonForVisit]
      })
    ]);
  };

  loadOpenedEncounters = async () => {
    let linkedEocId: string | undefined;

    const calendarEventId = this.root.routing.match(routes.records.appointment)
      ?.params.calendarEventId;

    // have to check for the condition linked to the calendarEvent we clicked "Start consult" as if no liked encounter it will just load the most recent encounter
    if (calendarEventId) {
      const calendarEvent =
        await this.booking.getCalendarEvent(calendarEventId);
      if (calendarEvent) {
        linkedEocId = calendarEvent.episodeOfCareId ?? undefined;
      }
    }

    // this will return the correct number of encounters for all scenarios
    //- if appointment is linked to a condition Only one as you can only have one open encounter per condition
    //- if not linked to a condition all open encounters for this patient/user
    //- if not have multiEncounter permission only one as you can only have one open encounter anyways
    const openEncounters = await this.clinical.getEncounters({
      patientId: this.patientId,
      userIds: this.userId ? [this.userId] : undefined,
      episodeOfCareIds: linkedEocId ? [linkedEocId] : undefined,
      statuses: [EncounterStatus.Open, EncounterStatus.Committed]
    });

    return openEncounters;
  };
}
